
import React from 'react';
import {css} from 'emotion';
import {formDefinitionFillIds} from '../../../helpers/formDefinitionFillIds.js';
import {IconDrag} from '../../../frontend/icons/IconDrag.jsx';
import {ReactSortable} from 'react-sortablejs';

export const FormEditNavigation = function (props) {

  const labelPrettify = (val) => {
    return String(val)
      .replace(/\<[^>]*\>/sg, '')
      .replace(/&nbsp;/sg, ' ')
      .replace(/[\r\n\t ]+/sg, ' ')
      .trim()
    ;
  };

  const blockName = (block, fallbackName) => {
    if (block.component == 'DropdownInput')
      //return 'Q: ' + labelPrettify(block.props?.label).substr(0, 10) + '...';
      return 'Q: ' + labelPrettify(block.props?.label ?? '(empty)');
    if (block.component == 'Group')
      return 'Group: ' + fallbackName;
    if (block.component == 'HTML')
      //return 'HTML: ' + labelPrettify(block.props?.html).substr(0, 10) + '...';
      return 'HTML: ' + labelPrettify(block.props?.html ?? '(empty)');
    if (block.component == 'MultiLineTextInput')
      //return 'Q: ' + labelPrettify(block.props?.label).substr(0, 10) + '...';
      return 'Q: ' + labelPrettify(block.props?.label ?? '(empty)');
    if (block.component == 'OpinionScaleInput')
      //return 'Q: ' + labelPrettify(block.props?.label).substr(0, 10) + '...';
      return 'Q: ' + labelPrettify(block.props?.label ?? '(empty)');
    if (block.component == 'SingleLineTextInput')
      //return 'Q: ' + labelPrettify(block.props?.label).substr(0, 10) + '...';
      return 'Q: ' + labelPrettify(block.props?.label ?? '(empty)');
    return fallbackName;
  };

  return (<>
    <div
      className={css`
        width: 100%;
        border-style: solid;
        border-width: 1px;
        border-color: #d1d5db;
        padding: 0 16px;
        height: auto;
      `}
    >
      <ReactSortable
        list={props.definitionAST().pages.map(v => ({item: v}))}
        setList={(state) => {
          props.definitionAST({...props.definitionAST(), pages: state.map(i => i.item)});
        }}
        // @see https://sortablejs.github.io/Sortable/#nested
        group="form-structure-pages"
        animation="150"
        fallbackOnBody="true"
        swapThreshold="0.65"
        // @see https://sortablejs.github.io/Sortable/#handle
        handle=".handle"
        filter=".filtered"
      >
        {props.definitionAST().pages.map((page, pageIndex) => (<>
          <div
            key={pageIndex}
            className={css`
              pointer-events: auto;
              cursor: pointer;
            `}
          >
            <div
              className={css`
                display: flex;
                ${true
                  && pageIndex == props.pageActiveIndex()
                  && -1 == props.blockActiveIndex()
                  && -1 == props.subBlockActiveIndex()
                  && `
                    font-weight: 700;
                  `
                }
              `}
              onClick={(e) => {
                props.pageActiveIndex(pageIndex);
                props.blockActiveIndex(-1);
                props.subBlockActiveIndex(-1);
              }}
            >
              <div
                className={'handle ' + css`
                  display: grid;
                  place-content: center;
                  place-items: center;
                  width: 32px;
                  cursor: move;
                `}
              >
                <IconDrag />
              </div>
              <div
                className={css`
                  flex: 1;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                `}
              >
                Page {pageIndex + 1}
              </div>
              <div
                className={css`
                  flex: none;
                `}
              >
                <button
                  className={css`
                    display: inline-block;
                    padding: 4px;
                  `}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const pageIndex = props.definitionAST().pages.findIndex(v => v === page);
                    props.definitionAST({
                      ...props.definitionAST(),
                      pages: [
                        ...props.definitionAST().pages.slice(0, pageIndex),
                        ...props.definitionAST().pages.slice(pageIndex + 1),
                      ],
                    });
                  }}
                >
                  X
                </button>
              </div>
            </div>
            <div
              className={css`
                padding-left: 16px;
              `}
            >
              <ReactSortable
                list={page.blocks.map(v => ({item: v}))}
                setList={(state) => {
                  const pageIndex = props.definitionAST().pages.findIndex(v => v === page);
                  props.definitionAST({
                    ...props.definitionAST(),
                    pages: [
                      ...props.definitionAST().pages.slice(0, pageIndex),
                      (() => {
                        const page = props.definitionAST().pages[pageIndex];
                        page.blocks = state.map(i => i.item);
                        return page;
                      })(),
                      ...props.definitionAST().pages.slice(pageIndex + 1),
                    ],
                  });
                }}
                // @see https://sortablejs.github.io/Sortable/#nested
                group="form-structure-blocks"
                animation="150"
                fallbackOnBody="true"
                swapThreshold="0.65"
                // @see https://sortablejs.github.io/Sortable/#handle
                handle=".handle"
                filter=".filtered"
              >
                {page.blocks.map((block, blockIndex) => (<>
                  <div
                    key={blockIndex}
                    className={css`
                      pointer-events: auto;
                      cursor: pointer;
                    `}
                  >
                    <div
                      className={css`
                        display: flex;
                        pointer-events: auto;
                        cursor: pointer;
                        ${true
                          && pageIndex == props.pageActiveIndex()
                          && blockIndex == props.blockActiveIndex()
                          && -1 == props.subBlockActiveIndex()
                          && `
                            font-weight: 700;
                          `
                        }
                      `}
                      onClick={(e) => {
                        props.pageActiveIndex(pageIndex);
                        props.blockActiveIndex(blockIndex);
                        props.subBlockActiveIndex(-1);
                      }}
                    >
                      <div
                        className={'handle ' + css`
                          display: grid;
                          place-content: center;
                          place-items: center;
                          width: 32px;
                          cursor: move;
                        `}
                      >
                        <IconDrag />
                      </div>
                      <div
                        className={css`
                          flex: 1;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                        `}
                      >
                        {blockName(block, `Block ${blockIndex + 1}`)}
                      </div>
                      <div
                        className={css`
                          flex: none;
                        `}
                      >
                        <button
                          className={css`
                            display: inline-block;
                            padding: 4px;
                          `}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            const pageIndex = props.definitionAST().pages.findIndex(v => v === page);
                            const blockIndex = props.definitionAST().pages[pageIndex].blocks.findIndex(v => v === block);
                            props.definitionAST({
                              ...props.definitionAST(),
                              pages: [
                                ...props.definitionAST().pages.slice(0, pageIndex),
                                (() => {
                                  const page = props.definitionAST().pages[pageIndex];
                                  page.blocks = [
                                    ...props.definitionAST().pages[pageIndex].blocks?.slice?.(0, blockIndex),
                                    ...props.definitionAST().pages[pageIndex].blocks?.slice?.(blockIndex + 1),
                                  ];
                                  return page;
                                })(),
                                ...props.definitionAST().pages.slice(pageIndex + 1),
                              ],
                            });
                          }}
                        >
                          X
                        </button>
                      </div>
                    </div>
                    <div
                      className={css`
                        padding-left: 32px;
                      `}
                    >
                      <ReactSortable
                        list={(block.blocks ?? []).map(v => ({item: v}))}
                        setList={(state) => {
                          const pageIndex = props.definitionAST().pages.findIndex(v => v === page);
                          const blockIndex = props.definitionAST().pages[pageIndex].blocks.findIndex(v => v === block);
                          props.definitionAST({
                            ...props.definitionAST(),
                            pages: [
                              ...props.definitionAST().pages.slice(0, pageIndex),
                              (() => {
                                const page = props.definitionAST().pages[pageIndex];
                                page.blocks = [
                                  ...props.definitionAST().pages[pageIndex].blocks?.slice?.(0, blockIndex),
                                  (() => {
                                    const block = props.definitionAST().pages[pageIndex].blocks?.[blockIndex];
                                    block.blocks = state.map(i => i.item);
                                    return block;
                                  })(),
                                  ...props.definitionAST().pages[pageIndex].blocks?.slice?.(blockIndex + 1),
                                ];
                                return page;
                              })(),
                              ...props.definitionAST().pages.slice(pageIndex + 1),
                            ],
                          });
                        }}
                        // @see https://sortablejs.github.io/Sortable/#nested
                        group="form-structure-blocks"
                        animation="150"
                        fallbackOnBody="true"
                        swapThreshold="0.65"
                        // @see https://sortablejs.github.io/Sortable/#handle
                        handle=".handle"
                        filter=".filtered"
                      >
                        {(block.blocks ?? []).map((subBlock, subBlockIndex) => (<>
                          <div
                            key={subBlockIndex}
                            className={css`
                              display: flex;
                              pointer-events: auto;
                              cursor: pointer;
                              ${true
                                && pageIndex == props.pageActiveIndex()
                                && blockIndex == props.blockActiveIndex()
                                && subBlockIndex == props.subBlockActiveIndex()
                                && `
                                  font-weight: 700;
                                `
                              }
                            `}
                            onClick={(e) => {
                              props.pageActiveIndex(pageIndex);
                              props.blockActiveIndex(blockIndex);
                              props.subBlockActiveIndex(subBlockIndex);
                            }}
                          >
                            <div
                              className={'handle ' + css`
                                display: grid;
                                place-content: center;
                                place-items: center;
                                width: 32px;
                                cursor: move;
                              `}
                            >
                              <IconDrag />
                            </div>
                            <div
                              className={css`
                                flex: 1;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                              `}
                            >
                              {blockName(subBlock, `Sub-Block ${subBlockIndex + 1}`)}
                            </div>
                            <div
                              className={css`
                                flex: none;
                              `}
                            >
                              <button
                                className={css`
                                  display: inline-block;
                                  padding: 4px;
                                `}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  const pageIndex = props.definitionAST().pages.findIndex(v => v === page);
                                  const blockIndex = props.definitionAST().pages[pageIndex].blocks.findIndex(v => v === block);
                                  props.definitionAST({
                                    ...props.definitionAST(),
                                    pages: [
                                      ...props.definitionAST().pages.slice(0, pageIndex),
                                      (() => {
                                        const page = props.definitionAST().pages[pageIndex];
                                        page.blocks = [
                                          ...props.definitionAST().pages[pageIndex].blocks?.slice?.(0, blockIndex),
                                          (() => {
                                            const block = props.definitionAST().pages[pageIndex].blocks?.[blockIndex];
                                            block.blocks = block.blocks.filter(v => v !== subBlock)
                                            return block;
                                          })(),
                                          ...props.definitionAST().pages[pageIndex].blocks?.slice?.(blockIndex + 1),
                                        ];
                                        return page;
                                      })(),
                                      ...props.definitionAST().pages.slice(pageIndex + 1),
                                    ],
                                  });
                                }}
                              >
                                X
                              </button>
                            </div>
                          </div>
                        </>))}
                      </ReactSortable>
                      {block.component == 'Group' && <>
                        <div>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              const pageIndex = props.definitionAST().pages.findIndex(v => v === page);
                              const blockIndex = props.definitionAST().pages[pageIndex].blocks.findIndex(v => v === block);
                              props.definitionAST(formDefinitionFillIds({
                                ...props.definitionAST(),
                                pages: [
                                  ...props.definitionAST().pages.slice(0, pageIndex),
                                  (() => {
                                    const page = props.definitionAST().pages[pageIndex];
                                    page.blocks = [
                                      ...props.definitionAST().pages[pageIndex].blocks?.slice?.(0, blockIndex),
                                      (() => {
                                        const block = props.definitionAST().pages[pageIndex].blocks?.[blockIndex];
                                        block.blocks.push({
                                          component: 'SingleLineTextInput',
                                          props: {},
                                          metadata: {},
                                        });
                                        return block;
                                      })(),
                                      ...props.definitionAST().pages[pageIndex].blocks?.slice?.(blockIndex + 1),
                                    ];
                                    return page;
                                  })(),
                                  ...props.definitionAST().pages.slice(pageIndex + 1),
                                ],
                              }));
                            }}
                          >
                            Add sub-block
                          </button>
                        </div>
                      </>}
                    </div>
                  </div>
                </>))}
              </ReactSortable>
              <div>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const pageIndex = props.definitionAST().pages.findIndex(v => v === page);
                    props.definitionAST(formDefinitionFillIds({
                      ...props.definitionAST(),
                      pages: [
                        ...props.definitionAST().pages.slice(0, pageIndex),
                        (() => {
                          const page = props.definitionAST().pages[pageIndex];
                          page.blocks.push({
                            component: 'SingleLineTextInput',
                            props: {},
                            metadata: {},
                          });
                          return page;
                        })(),
                        ...props.definitionAST().pages.slice(pageIndex + 1),
                      ],
                    }));
                  }}
                >
                  Add block
                </button>
              </div>
            </div>
          </div>
        </>))}
      </ReactSortable>
      <div>
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            props.definitionAST(formDefinitionFillIds({
              ...props.definitionAST(),
              pages: [
                ...props.definitionAST().pages,
                {
                  blocks: [],
                },
              ],
            }));
          }}
        >
          Add page
        </button>
      </div>
      <div>
        {props.underTheHood && (<>
          <div
            className={css`
              pointer-events: auto;
              cursor: pointer;
              ${true
                && props.pageActiveIndex() == -1
                && `
                  font-weight: 700;
                `
              }
            `}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              props.pageActiveIndex(-1);
            }}
          >
            Under the Hood
          </div>
        </>)}
      </div>
    </div>
  </>);

};
